import { jsx } from "react/jsx-runtime";
import { IconButton } from "@ane/ui-components/lib/components/Button";
import { ErrorStorageProperties } from "@ane/core/lib/models";
import { HelpRoute } from "@ane/exp-data/lib/routes/HelpRoute.utils";
import NavigationService from "@ane/core/lib/services/NavigationService";
const FileATicketButton = ({
  issue,
  errorMessage,
  correlationId
}) => {
  return /* @__PURE__ */ jsx(
    IconButton,
    {
      ariaLabel: "File a Ticket",
      role: "link",
      href: NavigationService.getCustomQueryParams(`${HelpRoute.routes.root.getSourceUrl({ source: "expErrorMessage" })}`),
      target: "_blank",
      iconProps: {
        iconName: "NavigateExternalInline"
      },
      styles: {
        root: {
          width: "auto",
          height: "16px",
          lineHeight: "16px"
        }
      },
      onClick: () => {
        sessionStorage.setItem(ErrorStorageProperties.expErrorIssue, issue);
        sessionStorage.setItem(ErrorStorageProperties.expErrorDescription, errorMessage);
        sessionStorage.setItem(ErrorStorageProperties.expErrorClientRequestId, correlationId);
      },
      children: "File a Ticket"
    }
  );
};
export {
  FileATicketButton
};
//# sourceMappingURL=FileATicketButton.js.map
